module.exports = __webpack_public_path__ + "static/media/TradeUnlisted.dfbfc2e3.png";